/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';

import { PanelTypes, PanelState } from './types';

const INITIAL_STATE: PanelState = {
  panel: {
    show_expiration_alert: false,
    allow_robot: false,
    days_to_end: 0,
    partner_id: false,
    four_months_left_to_renew: false,
    robo_access: false,
    dr_licita_access: false,
    representant_access: false,
    banner_robo_access: false,
    banner_new_robo_access: false,
    registration_type_validation: 0,
    view_modal_experient: false,
    validate_services: {
      gerenciar_documentos: true,
      monitorar_chat: true,
      assinatura_digital: false,
      robo: false,
      conlicitago: true,
      course_iaml: false,
      dr_licita: false,
    },
    view_panel: 'painel',
    view_modal_register: true,
    view_modal_experient_status: true,
    renewal_plans: false,
    course_released: false,
    bid_winner: {
      winner: false,
      edital: '',
      orgao_nome: '',
      contato_nome: '',
    },
    renewal_campaign: {
      released_online: false,
      contact_name: '',
      campaign_phase: 1,
      subscription_end_date: '',
      view_modal: false,
    },
    beebeeate_portals: [],
    services_paralyzed: {
      gerenciar_documentos: false,
      monitorar_chat: false,
      assinatura_digital: false,
      robo: false,
      conlicitago: false,
      course_iaml: false,
      dr_licita: false,
    },
    list_tools_shortcuts: [],
    evaluated: false,
    modal_ia: false,
    return_package: '',
    show_prize_roulette: false,
    modal_25_anos: false,
    view_modal_search: false,
    prize: {},
    roulette_elegible: false,
    roulette_header: false,
  },
  request: {
    loading: false,
    loaded: false,
    error: false,
  },
  request_send_feedback: {
    loading: false,
    loaded: false,
    error: false,
  },
};

const reducer: Reducer<PanelState> = (
  state = INITIAL_STATE,
  { type, result, page, status_modal, status_modal_experient, video_ia, prize_roulette, prize },
) => {
  return produce(state, (draft) => {
    switch (type) {
      case PanelTypes.SHOW_REQUEST:
        draft.request.loading = true;
        break;
      case PanelTypes.SHOW_SUCCESS:
        if (!result) return;
        draft.panel.show_expiration_alert = result.data.show_expiration_alert;
        draft.panel.allow_robot = result.data.allow_robot;
        draft.panel.days_to_end = result.data.days_to_end;
        draft.panel.partner_id = result.data.partner_id;
        draft.panel.four_months_left_to_renew = result.data.four_months_left_to_renew;
        draft.panel.robo_access = result?.data?.robo_access;
        draft.panel.dr_licita_access = result?.data?.dr_licita_access;
        draft.panel.representant_access = result?.data?.representant_access;
        draft.panel.banner_robo_access = result?.data?.banner_robo_access;
        draft.panel.banner_new_robo_access = result?.data?.banner_new_robo_access;
        draft.panel.validate_services.gerenciar_documentos =
          result?.data?.validate_services?.gerenciar_documentos;
        draft.panel.validate_services.monitorar_chat =
          result?.data?.validate_services?.monitorar_chat;
        draft.panel.validate_services.assinatura_digital =
          result?.data?.validate_services?.assinatura_digital;
        draft.panel.validate_services.robo = result?.data?.validate_services?.robo;
        draft.panel.validate_services.conlicitago = result?.data?.validate_services?.conlicitago;
        draft.panel.validate_services.course_iaml = result?.data?.validate_services?.course_iaml;
        draft.panel.validate_services.dr_licita = result?.data?.validate_services?.dr_licita;
        draft.panel.registration_type_validation =
          result?.data?.registration_type_validation?.status_register;
        draft.panel.renewal_plans = result?.data?.renewal_plans;
        draft.panel.view_modal_experient = result?.data?.view_modal_experient?.view_modal;
        draft.panel.course_released = result?.data?.course_released;
        draft.panel.bid_winner = result?.data?.bid_winner;
        draft.panel.renewal_campaign = result?.data?.renewal_campaign;
        draft.panel.view_modal_search = result?.data?.view_modal_search;
        draft.panel.list_tools_shortcuts = result.data?.list_tools_shortcuts;
        draft.panel.evaluated = result?.data?.evaluated;
        draft.panel.return_package = result?.data?.return_package;
        draft.panel.beebeeate_portals = result?.data?.beebeeate_portals;
        draft.panel.roulette_elegible = result?.data?.roulette_elegible;
        draft.panel.roulette_header = result?.data?.roulette_header;
        draft.panel.services_paralyzed.gerenciar_documentos =
          result?.data?.services_paralyzed?.gerenciar_documentos;
        draft.panel.services_paralyzed.monitorar_chat =
          result?.data?.services_paralyzed?.monitorar_chat;
        draft.panel.services_paralyzed.assinatura_digital =
          result?.data?.services_paralyzed?.assinatura_digital;
        draft.panel.services_paralyzed.robo = result?.data?.services_paralyzed?.robo;
        draft.panel.services_paralyzed.conlicitago = result?.data?.services_paralyzed?.conlicitago;
        draft.panel.services_paralyzed.course_iaml = result?.data?.services_paralyzed?.course_iaml;
        draft.panel.services_paralyzed.dr_licita = result?.data?.services_paralyzed?.dr_licita;
        draft.request = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case PanelTypes.SHOW_FAILURE:
        draft.panel = INITIAL_STATE.panel;
        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case PanelTypes.SEND_FEEDBACK_REQUEST:
        draft.request_send_feedback = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case PanelTypes.SEND_FEEDBACK_SUCCESS:
        draft.request_send_feedback = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case PanelTypes.SEND_FEEDBACK_FAILURE:
        draft.request_send_feedback = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case PanelTypes.SHOW_DASHBOARD:
        draft.panel.view_panel = page;
        break;
      case PanelTypes.UPDATE_STATUS_REGISTER_MODAL:
        draft.panel.view_modal_register = status_modal;
        break;
      case PanelTypes.UPDATE_STATUS_REGISTER_EXPERIENT_MODAL:
        draft.panel.view_modal_experient_status = status_modal_experient;
        break;
      case PanelTypes.SHOW_MODAL_IA:
        draft.panel.modal_ia = video_ia;
        break;
      case PanelTypes.SHOW_PRIZE_ROULLETE:
        draft.panel.show_prize_roulette = prize_roulette;
        break;
      case PanelTypes.SET_PRIZE:
        draft.panel.prize = prize;
        break;
      default:
    }
  });
};

export default reducer;
